export const sidebarOpen = ({ commit }) => {
  commit("TOGGLE_SIDEBAR");
};
